import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { MODULE_CALL_MAX_DEPTH } from '../../models/test-module.model';

/** Kennzeichen „Rekursiv“ für ein Modul, das sich selbst oder über andere Module wieder aufruft (NEX-2259). */
@Component({
  selector: 'app-recursive-badge',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconModule, MatTooltipModule, TranslateModule],
  templateUrl: './recursive-badge.component.html',
  styleUrl: './recursive-badge.component.scss',
})
export class RecursiveBadgeComponent {
  protected readonly depth = { max: MODULE_CALL_MAX_DEPTH };
}
